'use client';

import { useEffect, useState } from 'react';

export const useIsClient = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(globalThis.window !== undefined);
  }, []);

  return {
    isClient,
    isServer: !isClient,
  };
};
